import React from 'react';
import axios from 'axios';

import { createMuiTheme } from '@material-ui/core/styles';

// import material-ui core
import Grow from '@material-ui/core/Grow';

// import SnackbarProvider
import { SnackbarProvider } from 'notistack';

import {
  BrowserRouter as Router,
  Route,
  Redirect,
  Switch,
  Link,
} from 'react-router-dom';

// import routers constants
import { routers, PATH_FRONTOF_MASTER, PATH_BACKOF_MASTER } from './routers';

// import routers
import { sysURL } from './constants';
import { listRoutFrontOf, listRoutBackOf } from './routers';

import {
  base64,
  userProfiler,
  logger,
  clearLocalAccessData,
} from './utils/utils';

// import Contexts
import { MuiThemeProvider } from './contexts/ThemeContext';
import { DialogProvider } from './contexts/DialogContext';

// import Layout & Pages

// import MasterLayout
import MasterLayout from './components/layouts/MasterLayout';

// import PrepareUserInformationPage
import PrepareUserInformationPage from './components/pages/PrepareUserInformationPage';

// import LoginPage
import LoginPage from './components/pages/LoginPage';

// import AppSidebrRBack - AppSidebrRFront
import AppSidebarRBack from './components/fragments/AppSidebarRBack';
import AppSidebarRFront from './components/fragments/AppSidebarRFront';

// import Helpdesk*Page (FrontOffice)
import HelpdeskMainPage from './components/pages/HelpdeskMainPage';
import HelpdeskIssuesPage from './components/pages/HelpdeskIssuesPage';
import HelpdeskIssueActivitiesPage from './components/pages/HelpdeskIssueActivitiesPage';
import HelpdeskReportIssuePage from './components/pages/HelpdeskReportIssuePage';

// import Manage*Page (BackOffice)
import ManageIssuesPage from './components/pages/ManageIssuesPage';
import ManageIssueAcitivitiesPage from './components/pages/ManageIssueActivitiesPage';
import SettingPermissionPage from './components/pages/SettingPermissionPage';
import SettingLabelPage from './components/pages/SettingLabelPage';

import { accessible } from './data/issue';

/**
 * MuiTheme-themeFrontOffice
 */
const themeFrontOffice = createMuiTheme({
  palette: {
    primary: {
      light: '#4383cc',
      main: '#1565c0',
      dark: '#0e4686',
      contrastText: '#fff',
    },
  },
  shadows: [
    'none',

    // Paper
    '0px 1px 1px rgba(0, 0, 0, 0.25)',

    //Button
    'none',

    'none',
    'none',
    ...Array(20).fill('none'),
  ],
});

/**
 * MuiTheme-themeBackOffice
 */
const themeBackOffice = createMuiTheme({
  palette: {
    primary: {
      light: '#ffca28',
      main: '#ffb300',
      dark: '#b28704',
      contrastText: '#fff',
    },
    secondary: {
      light: '#ff4569',
      main: '#ff1744',
      dark: '#b2102f',
      contrastText: '#fff',
    },
  },
  shadows: [
    'none',

    // Paper
    '0px 1px 1px rgba(0, 0, 0, 0.25)',

    //Button
    'none',

    'none',
    'none',
    ...Array(20).fill('none'),
  ],
});

/**
 * CheckRefreshTokenWork()
 * Check RefreshToken is worked (No expire)
 * @returns {bool}
 */
async function CheckRefreshTokenWork() {
  try {
    let { data } = await axios.get(sysURL.accessToken);
    if (data.tokenAccess) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
}

/**
 * CheckAccessibleIssueById()
 * @param {*} mode
 * @param {*} id
 * @returns
 */
async function CheckAccessibleIssueById(mode, id) {
  try {
    if (!mode) throw 'CheckAccessibleIssueById no mode';
    let accessStatus = await accessible({
      package: base64.encodeObj({ mode, id }),
    });
    return accessStatus;
  } catch (error) {
    throw error;
  }
}
const LoginRoute = ({ component: Component, ...rest }) => {
  return <Route
    {...rest}
    render={(props) => {
      CheckRefreshTokenWork().then((work) => {
        if (work) {
          props.history.push(routers.frontOf.main.path);
        } else {
          props.history.push('/login');
        }
      });
    }}
  />;
};

// PrivateRoute (available on https://reactrouter.com/web/example/auth-workflow)
// A wrapper for <Route> that redirects to the login
// screen if you're not yet authenticated.
const PrivateRoute = ({ component: Component, ...rest }) => {
  return (
    <Route
      {...rest}
      render={(props) => {
        /**
         * Check user permission of this path
         */

        // 1 Get current path
        const path = props.match.path;

        // 2 Get path data from listRoutFront[-Back]Of by current path (1)
        const pathData = [...listRoutFrontOf, ...listRoutBackOf].find(
          (rout) => rout.path === path
        ) || { permissionLevel: [] };

        // 3 get path permissionLevel
        const pathPermLevel = pathData.permissionLevel;

        // 4 Get user permission level (from userProfile)
        const userProfile = userProfiler.getFromLocal();

        // Fixed full permission in PrepageUserInfomationPage (line: ~121, Please remove before up to production)
        const userPermLevel = userProfile.permission.level;

        // 5 FINAL: Check accessPermission (from userPermLevel compaire with pathPermLevel)
        const accessPermission = userPermLevel.some(
          (upl) => pathPermLevel.indexOf(upl) > -1
        );

        // Check token [and accessible issue if params.id exist in match (route)]
        // - Check if refrechToken not work (Expired)
        // - [CheckAccessibleIssueById
        CheckRefreshTokenWork().then((work) => {
          // refrechToken not work
          if (!work) {
            props.history.push('/login');
          } else {
            // CheckAccessibleIssueById
            if (props.match.params.id) {
              let mode = '';
              let id = base64.decode(props.match.params.id);
              let sid = base64.decode(props.match.params.sid);
              if (path === routers.frontOf.issue.path) {
                mode = 'reporter';
              } else if (path === routers.backOf.issue.path) {
                mode = 'staff';
              }
              CheckAccessibleIssueById(mode, id)
                .then((isAccess) => {
                  if (!isAccess) {
                    let message = base64.encode(`Can't access issue ${sid}.`);
                    return props.history.push(`/inaccessible/${message}`);
                  }
                })
                .catch((error) => {
                  return props.history.push(
                    `/inaccessible/${base64.encode(
                      `Error check accessible issue ${error}.`
                    )}`
                  );
                });
            }
          }
        });

        // Check access issue
        if (path)
          return accessPermission ? (
            <Component {...props} />
          ) : (
            <Redirect to="/unauthrolized" />
          );
      }}
    />
  );
};

function App() {
  const routFrontOf = routers.frontOf;
  const routBackOf = routers.backOf;

  return (
    <MuiThemeProvider>
      {/* SnackbarProvider has an imperative API that makes it easy to display dialog */}
      <SnackbarProvider
        hideIconVariant={false}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        maxSnack={1}
        TransitionComponent={Grow}
      >
        <DialogProvider>
          <Router>
            <Switch>
              {/* Login, UpdateUser Page */}
              <Route
                exact={true}
                path={[
                  '/login',
                  '/user/preparing',
                  '/unauthrolized',
                  '/inaccessible/:message',
                ]}
              >
                <MasterLayout muiTheme={themeFrontOffice} id="login">
                  <Route exact={true} path="/login" component={LoginPage} />
                  <Route
                    exact={true}
                    path="/user/preparing"
                    component={PrepareUserInformationPage}
                  />
                  {/* unauthrolized without message must clearLocalAccessData */}
                  <Route
                    exact={true}
                    path="/unauthrolized"
                    component={(props) => {
                      // clearLocalAccessData();
                      return (
                        <div align="center" style={{ color: 'red' }}>
                          <h3>Can't access this page.</h3>
                        </div>
                      );
                    }}
                  />
                  {/* unauthrolized with message ex con not access issue (Not clearLocalAccessData) */}
                  <Route
                    exact={true}
                    path="/inaccessible/:message"
                    component={(props) => {
                      let message = base64.decode(props.match.params.message);
                      return (
                        <div align="center" style={{ color: 'red' }}>
                          <h3>{message}</h3>
                          <Link to={routFrontOf.main.path}>Back to Main</Link>
                        </div>
                      );
                    }}
                  />
                </MasterLayout>
              </Route>

              {/**
               * Path - Front-Office (Reporting breach)
               */}
              <Route
                exact={true}
                path={[
                  routFrontOf.main.path,
                  routFrontOf.reportIssue.path,
                  routFrontOf.issues.path,
                ]}
              >
                <MasterLayout
                  id="front-office"
                  muiTheme={themeFrontOffice}
                  sidebar={true}
                  isAuthen
                >
                  <PrivateRoute
                    exact={true}
                    path={routFrontOf.main.path}
                    // component={HelpdeskMainPage}
                    component={HelpdeskReportIssuePage}
                  />
                  <PrivateRoute
                    exact={true}
                    path={routFrontOf.reportIssue.path}
                    component={HelpdeskReportIssuePage}
                  />
                  <PrivateRoute
                    exact={true}
                    path={routFrontOf.issues.path}
                    component={HelpdeskIssuesPage}
                  />
                </MasterLayout>
              </Route>
              <Route exact={true} path={[routFrontOf.issue.path]}>
                <MasterLayout
                  id="front-office-issue-activity"
                  muiTheme={themeFrontOffice}
                  sidebar
                  sidebarRight={<AppSidebarRFront />}
                  isAuthen
                >
                  <PrivateRoute
                    exact={true}
                    path={routFrontOf.issue.path}
                    component={HelpdeskIssueActivitiesPage}
                  />
                </MasterLayout>
              </Route>

              {/* Path - Back-Office (PDPA incident management) */}
              <Route
                exact={true}
                path={[
                  routBackOf.main.path,
                  routBackOf.report.path,
                  routBackOf.settingPermission.path,
                  routBackOf.settingLabel.path,
                ]}
              >
                <MasterLayout
                  id="back-office"
                  muiTheme={themeBackOffice}
                  sidebar
                  isAuthen
                >
                  <PrivateRoute
                    exact={true}
                    path={routBackOf.main.path}
                    component={ManageIssuesPage}
                  />
                  <PrivateRoute
                    exact={true}
                    path={routBackOf.report.path}
                    component={() => (
                      <React.Fragment>
                        <h2>รายงาน</h2>
                        <h3>Under Construction</h3>
                      </React.Fragment>
                    )}
                  />

                  <PrivateRoute
                    exact={true}
                    path={routBackOf.settingPermission.path}
                    component={SettingPermissionPage}
                  />

                  <PrivateRoute
                    exact={true}
                    path={routBackOf.settingLabel.path}
                    component={SettingLabelPage}
                  />
                </MasterLayout>
              </Route>

              <Route
                exact={true}
                path={[
                  routBackOf.issue.path,
                  //routBackOf.configPermission.path
                ]}
              >
                <MasterLayout
                  id="back-office-activity"
                  muiTheme={themeBackOffice}
                  sidebar
                  sidebarRight={<AppSidebarRBack />}
                  isAuthen
                >
                  <PrivateRoute
                    exact={true}
                    path={routBackOf.issue.path}
                    component={ManageIssueAcitivitiesPage}
                  />
                </MasterLayout>
              </Route>

              {/* Redirect to reportIssue if path is PATH_FRONTOF_MASTER */}
              <Route
                exact={true}
                path={PATH_FRONTOF_MASTER}
                component={() => <Redirect to={routFrontOf.reportIssue.path} />}
              />
              {/* Redirect to login if path is "/" */}
              <LoginRoute
                exact={true}
                path="/"
                component={() => <Redirect to="/login" />}
              />
              {/* Redirect to notpermission "/" */}
              {/* <Route
                exact={true}
                path="/"
                component={() => <Redirect to="/login" />}
              /> */}

              {/* Path not-exist in routers */}
              <Route
                component={() => (
                  <div align="center">
                    <h1>Page not Found</h1>
                  </div>
                )}
              />
            </Switch>
          </Router>
        </DialogProvider>
      </SnackbarProvider>
    </MuiThemeProvider>
  );
}

export default App;
